import React from "react";

export const useLocaleMessages = (locale: string) => {
  const messages = React.useMemo(() => {
    return require(`../lang/${locale}.json`);
  }, [locale]);

  return messages;
};
